import { computed, ref } from 'vue';

import { NavComposable, NavTopStyles } from '@/models/entities/nav.model';

import UtilsService from '@dh-io-otb/shared/src/services/utils.service';

const useNav = (): NavComposable => {
  const pendingUpdate = ref(false);

  const navTopPosition = ref(0);
  const navDealerTopPosition = ref(0);
  const otbHeader = ref(null);
  const otbHeaderReturn = ref(null);
  const otbSearchBar = ref(null);

  const navTopStyle = computed((): NavTopStyles => {
    return { top: `${navTopPosition.value}px`, 'will-change': 'top' };
  });

  const navTopStyleFixedDealer = computed((): NavTopStyles => {
    return { top: `${navDealerTopPosition.value}px`, 'will-change': 'top' };
  });

  const calculateNavTopPosition = (): void => {
    if (pendingUpdate.value) return;
    pendingUpdate.value = true;

    requestAnimationFrame(() => {
      pendingUpdate.value = false;

      const owcHeaderElement =
        (document.querySelector('owc-header') as HTMLElement) || (document.querySelector('.hp-header') as HTMLElement);
      const otbHeaderElement = otbHeader?.value as unknown as HTMLElement;
      const otbHeaderReturnElement = otbHeaderReturn?.value as unknown as HTMLElement;
      const otbHeaderIsExpanded = otbHeaderElement?.classList.contains('otb-main-header-container-expanded');
      const hasTwoFixedHeader = otbHeaderReturnElement?.classList.contains('otb-header-return--fixed');

      let joinedHeaders;
      if (otbHeaderElement) {
        const otbHeaderReturnHeight = otbHeaderReturnElement ? UtilsService.outerHeight(otbHeaderReturnElement) : 0;
        const otbHeaderHeight = UtilsService.outerHeight(otbHeaderElement);
        joinedHeaders =
          owcHeaderElement && !otbHeaderIsExpanded
            ? owcHeaderElement.offsetHeight + otbHeaderHeight + otbHeaderReturnHeight
            : otbHeaderHeight + otbHeaderReturnHeight;
        if (otbHeaderIsExpanded) {
          navTopPosition.value = joinedHeaders;
        } else if (window.pageYOffset < joinedHeaders) {
          if (!hasTwoFixedHeader) navTopPosition.value = joinedHeaders - window.pageYOffset;
          else if (window.pageYOffset < joinedHeaders - otbHeaderReturnHeight) {
            navTopPosition.value = joinedHeaders - window.pageYOffset;
          }
        } else {
          navTopPosition.value = hasTwoFixedHeader ? otbHeaderReturnHeight : 0;
        }
        navDealerTopPosition.value = navTopPosition.value - otbHeaderReturnHeight;
      }
    });
  };

  const navPositionScrollEvent = (): void => {
    window.addEventListener('scroll', calculateNavTopPosition);
    window.addEventListener('resize', calculateNavTopPosition);
    window.visualViewport?.addEventListener('scroll', calculateNavTopPosition);
    window.visualViewport?.addEventListener('resize', calculateNavTopPosition);
  };

  return {
    calculateNavTopPosition,
    navTopPosition,
    navPositionScrollEvent,
    navDealerTopPosition,
    navTopStyle,
    navTopStyleFixedDealer,
    otbHeader,
    otbHeaderReturn,
    otbSearchBar,
  };
};

export { useNav };
